<template>
  <div class="merchant_activity">
    <!-- <h1>acquirer</h1> -->

    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[
              { text: $t('merchant activity'), disabled: true, href: '/' },
            ]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact" @update:page="onPageChange">page</v-btn> -->
          <!-- <v-btn prepend-icon="mdi-plus" color="secondary" @click="compose">              
              <template v-slot:prepend >
                <v-icon color="white"></v-icon>
              </template>
              Add Activity
            </v-btn>    -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_activity") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          :loading="loading"
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="activities"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-3"
                color="green"
                @click="compose_update(item.raw.mccCode)"
                v-if="
                  this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_USER')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-4"
                color="red"
                @click="compose_delete(item.raw.mccCode)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.raw.mccCode)" >mdi-pencil</v-icon>
              <v-icon color="red" small @click="compose_delete(item.raw.mccCode)" >mdi-delete</v-icon> -->
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>

      <!-- <button @click="previousPage">gg</button>  <span>{{ page }} / {{ totalPages }}</span> <button @click="nextPage">kk</button> -->

      <!-- <v-data-table
          :headers="headers"
          :items="activities"
          :items-per-page="itemsPerPage"
          v-model:page="page"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          :server-items-length="totalItems"
          @update:page="fetchData"
          @update:items-per-page="fetchData"
          @update:sort-by="fetchData"
          @update:sort-desc="fetchData"
        >
          
        </v-data-table>  -->

      <!-- <v-data-table
          :headers="headers"
          :items="activities"
          :items-per-page="itemsPerPage"
          :page="page"
          :total-items="totalItems"
          :loading="loading"          
        >
          
        </v-data-table> -->
    </v-card>

    <!-- ADD DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_activity") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                       :label="$t('activity')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="activity_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label=" MCC*"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="activity_data.f_mcc"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addActivity"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_activity") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                       :label="$t('activity')"
                      required
                      v-model="activity_data.f_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label=" MCC*"
                      required
                      v-model="activity_data.f_mcc"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateActivity"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="deleteActivity">Delete</v-btn>                  
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteActivity">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script setup></script>

<script>
import axios from "axios";

export default {
  name: "Acquirer",
  props: {
    msg: String,
  },

  data() {
    return {
      name: "",
      emits: ["reload"],
      activities: [], //used
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      activity_data: {
        //used
        f_name: "",
        f_mcc: "",
      },

      activityId: "",
      search: "",
      headers: [
        {
          title: this.$t("activity"),
          align: "start",
          sortable: false,
          key: "mccName",
        },
        { title: "MCC", key: "mccCode" },
        { title:  this.$t("Actions"), key: "actions", sortable: false },
      ],

      //form
      form: false,
      loading: true,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    /* itemsPerPage(){
          this.page = 1 ;
          this.fetchData();
        } */
    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },

    /* search (){          
          this.searchData()
        } */
  },

  methods: {
    onPageChange(newPage) {
      this.page = newPage;
      // console.log("page", this.page);
      //this.fetchData()
    },

    /* previousPage() {
        if(this.page > 1){
          this.page--;
        }
      },

      nextPage() {
        if(this.page < this.totalPages){
          this.page++;
        }
      }, */

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.activity_data.f_name = "";
      this.activity_data.f_mcc = "";
    },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      //this.requests_handler()
    },

    compose_update(id) {
      this.activityId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.activityId = id;
      this.dialog_delete = true;
    },

    async addActivity() {
      //this.dialog = false
      // console.log("form data", this.activity_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "mcc",
          {
            mccName: this.activity_data.f_name,
            mccCode: this.activity_data.f_mcc,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 201) {
          this.$root.vtoast.show({ message:  this.$t("activity_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //console.warn("error", error.response.data.error);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "" + "mcc/" + this.activityId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((activity_response) => {
            // console.log("data1", activity_response.data);

            //get data for selected id and display data in for dialog
            if (activity_response.status == 200) {
              //console.log("activity Data", this.activity_response.data)
              this.activity_data.f_name = activity_response.data.mccName;
              this.activity_data.f_mcc = activity_response.data.mccCode;
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateActivity() {
      //this.dialog_update = false
      // console.log("update form id", this.orgId);
      // console.log("update form activity", this.org_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.put(
          window.baseurl + "" + "mcc/" + "" + this.activityId,
          {
            mccName: this.activity_data.f_name,
            mccCode: this.activity_data.f_mcc,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form activity result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message:  this.$t("activity_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        // console.warn("error", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteActivity() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "" + "mcc/" + this.activityId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          //alert("successfull deleted");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message:  this.$t("activity_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        // console.warn("error", error.response.data.error);
        //this.show_toast(true, "warning", error.response.data.message);
        this.$root.vtoast.showError({ message: error.response.data.error });
      }
    },

    async fetchData() {
      // console.log("in fecthData", this.page);
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          /* result = await axios.get(window.baseurl+"mcc",  
            { "params": { page: 1, pagesize: 30 } },
            {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
            ); */
          result = await axios.get(window.baseurl + "mcc", {
            params: { page: page2, pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("activity_object", result);
          this.activities = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }
      } catch (error) {
        this.show_toast(true, "warning", error.message);
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          /* result = await axios.get(window.baseurl+"mcc",  
            { "params": { page: 1, pagesize: 30 } },
            {"headers": {'Authorization': 'Bearer ' + this.accessToken} }
            ); */
          result = await axios.get(window.baseurl + "mcc/search", {
            params: { page: page2, pagesize: 100, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("activity_search_object", result);
          this.activities = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }
      } catch (error) {
        this.show_toast(true, "warning", error.message);
        this.loading = false;
      }
    },
  },
  //get list of acquirers
  async mounted() {
    // console.log("in fecthData11", this.page);
    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search_row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
